var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.newCampaign && !_vm.franchise)?_c('mf-action-buttons',{attrs:{"primary-button":{
      text: 'Ativar campanha',
      action: _vm.saveActive,
      isVisible: true,
      isLoading: _vm.loading.saveActive,
      isDisabled: _vm.anyLoading && !_vm.loading.saveActive,
    },"secondary-button":{
      text: 'Salvar rascunho',
      action: _vm.saveDraft,
      isVisible: true,
      isLoading: _vm.loading.saveDraft,
      isDisabled: _vm.anyLoading && !_vm.loading.saveDraft,
    },"cancel-button":{
      text: 'Cancelar',
      action: _vm.redirectCampanhas,
      isVisible: true,
    }}}):(_vm.scheduledCampaign && !_vm.franchise)?_c('mf-action-buttons',{attrs:{"primary-button":{
      text: 'Salvar alterações',
      action: _vm.saveActive,
      isVisible: true,
      isLoading: _vm.loading.saveActive,
      isDisabled: _vm.anyLoading && !_vm.loading.saveActive,
    },"secondary-button":{
      text: 'Desativar',
      action: _vm.disableDraft,
      isVisible: true,
      isLoading: _vm.loading.disableDraft,
      isDisabled: _vm.anyLoading && !_vm.loading.saveDraft,
    },"cancel-button":{
      text: 'Cancelar',
      action: _vm.redirectCampanhas,
      isVisible: true,
    }}}):(_vm.finishedCampaign && !_vm.franchise)?_c('mf-action-buttons',{attrs:{"primary-button":{
      text: 'Duplicar',
      action: _vm.clone,
      isVisible: true,
      isLoading: _vm.loading.clone,
      isDisabled: _vm.anyLoading && !_vm.loading.clone,
    },"cancel-button":{
      text: 'Cancelar',
      action: _vm.redirectCampanhas,
      isVisible: true,
    }}}):(_vm.draftCampaign && !_vm.franchise)?_c('mf-action-buttons',{attrs:{"primary-button":{
      text: 'Ativar campanha',
      action: _vm.saveActive,
      isVisible: true,
      isLoading: _vm.loading.saveActive,
      isDisabled: _vm.anyLoading && !_vm.loading.saveActive,
    },"secondary-button":{
      text: 'Salvar alterações',
      action: _vm.saveDraft,
      isVisible: true,
      isLoading: _vm.loading.saveDraft,
      isDisabled: _vm.anyLoading && !_vm.loading.saveDraft,
    },"extra-button":{
      text: 'Apagar rascunho',
      action: _vm.deleteCampaign,
      isVisible: true,
      isLoading: _vm.loading.deleteCampaign,
      isDisabled: _vm.anyLoading && !_vm.loading.deleteCampaign,
    },"cancel-button":{
      text: 'Cancelar',
      action: _vm.redirectCampanhas,
      isVisible: true,
    }}}):(_vm.activeCampaign && !_vm.franchise)?_c('mf-action-buttons',{attrs:{"primary-button":{
      text: 'Salvar alterações',
      action: _vm.saveActive,
      isVisible: true,
      isLoading: _vm.loading.saveDraft,
      isDisabled: _vm.anyLoading && !_vm.loading.saveDraft,
    },"secondary-button":{
      text: 'Finalizar',
      action: _vm.finalizeCommercial,
      isVisible: true,
      isLoading: _vm.loading.saveActive,
      isDisabled: _vm.anyLoading && !_vm.loading.saveActive,
    },"cancel-button":{
      text: 'Cancelar',
      action: _vm.redirectCampanhas,
      isVisible: true,
    }}}):(_vm.franchise)?_c('mf-action-buttons',{attrs:{"primary-button":{
      text: 'Fechar',
      action: _vm.redirectCampanhas,
      isVisible: true,
    }}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }